import { createMultiStyleConfigHelpers as r, cssVar as e } from "@chakra-ui/react";
import { popoverAnatomy as t } from "@chakra-ui/anatomy";
import p from "../dataDisplay/closeButton.mjs";
const { defineMultiStyleConfig: a, definePartsStyle: d } = r(t.keys), o = e("popper-bg"), l = e("popper-arrow-bg"), i = e("popper-arrow-shadow-color"), s = {
  md: d({ body: { maxW: "md" } })
}, c = a({
  baseStyle: {
    popper: {
      zIndex: "popover"
    },
    content: {
      border: "1px solid",
      borderColor: "gray.200",
      borderRadius: "lg",
      boxShadow: "lg",
      zIndex: "inherit",
      [o.variable]: "colors.white",
      bg: o.reference,
      [l.variable]: o.reference,
      [i.variable]: "colors.gray.200",
      _focusVisible: {
        outline: 0,
        boxShadow: "outline"
      },
      ".headerspacer": {
        height: "20px"
      }
    },
    header: {
      paddingLeft: 4,
      paddingRight: 10,
      py: 2,
      borderBottomWidth: "1px",
      borderColor: "gray.200",
      textStyle: "bodyBoldSmall"
    },
    body: {
      py: 2,
      px: 4,
      textStyle: "bodySmall"
    },
    footer: {
      px: 3,
      py: 2,
      borderTopWidth: "1px",
      borderColor: "gray.200"
    },
    closeButton: {
      ...p.baseStyle,
      position: "absolute",
      top: 1,
      insetEnd: 1
    }
  },
  sizes: s,
  variants: {
    fullWidth: {
      popper: {
        width: "100%"
      }
    }
  },
  defaultProps: {
    size: "md"
  }
});
export {
  c as default
};
